'use client';

import { ReactNode } from 'react';

import { slate } from '@/lib/colours';

import {
  Box,
  Grid2,
  PageHeading,
  RadioGroup,
  SectionTab,
  Typography,
} from '@/primitives';

export interface Step {
  title: ReactNode;
  subTitle: ReactNode;
  value: string;
  completed?: boolean;
}

export interface StepsPanelProps {
  children: ReactNode;
  currentStep: string;
  header?: ReactNode;
  steps: Step[];
  subTitle: ReactNode;
  title: ReactNode;
}

export function MultiStepLayout({
  children,
  currentStep,
  header,
  steps,
  subTitle,
  title,
}: StepsPanelProps) {
  return (
    <Grid2 container spacing="24px">
      <Grid2 xs={3}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: '16px',
              padding: '0 24px 24px',
            }}
          >
            {header}
            <PageHeading>{title}</PageHeading>
            <Typography variant="bodymedium" color={slate[500]}>
              {subTitle}
            </Typography>
          </Box>
          <RadioGroup
            value={currentStep}
            sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}
          >
            {steps.map((step, index) => {
              return (
                <SectionTab
                  key={step.value}
                  title={
                    <>
                      {index + 1}. {step.title}
                    </>
                  }
                  subTitle={step.subTitle}
                  value={step.value}
                  completed={
                    currentStep === step.value ? false : step.completed
                  }
                />
              );
            })}
          </RadioGroup>
        </Box>
      </Grid2>
      <Grid2 xs={9}>{children}</Grid2>
    </Grid2>
  );
}
